export const makerSVGContent = (content = 1) => {
    const contentForSingleDigit = () => {
        return ` <text font-family="Inter" font-size="20" font-weight="500" y="40" fill="black">
                   ${content}
                </text>`
    }

    return `<svg
      width="41"
      height="52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.813 49.756L6.663 33.47C.132 25.955.502 14.62 7.51 7.556a18.703 18.703 0 0126.605 0c7.007 7.065 7.378 18.399.848 25.914l-14.15 16.286z"
        fill="#282828"
      />
      <path
        d="M7.789 20.813c0-7.193 5.83-13.024 13.024-13.024 7.193 0 13.024 5.83 13.024 13.024 0 7.193-5.831 13.024-13.024 13.024-7.193 0-13.024-5.831-13.024-13.024z"
        fill="#fff"
      />
      <path
        d="M20.37 50.141l.443.511.444-.51 14.15-16.287c6.731-7.747 6.35-19.43-.874-26.713-7.577-7.64-19.863-7.64-27.44 0-7.224 7.284-7.606 18.966-.874 26.713l14.15 16.286z"
        stroke="#fff"
        stroke-width="1.176"
      />
              <svg>
                 ${contentForSingleDigit()}
              </svg>
        </svg>`
}
